
import { faArchive, faArrowRotateLeft, faCheck, faCreditCard, faEdit, faFlagCheckered, faForward, faPaperPlane, faPlay, faPlus, faReceipt, faSave, faSync, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./SrvButton.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SrvButton({ typeBtn, textBtn, onClick, loading, size }) {
   /*
   type:
    add - Добавление
    edit - Редактирование
    remove - Удаление
    save - Сохранение
    finish - Завершение
    play - 
    pay- оплата
    extend- продлить
   */


   return (
      <>
         {typeBtn === "add" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faPlus} /></i>
               {textBtn === undefined ? 'Добавить' : textBtn}
            </button>
         )}
         {typeBtn === "edit" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faEdit} /></i>
               {textBtn === undefined ? 'Изменить' : textBtn}
            </button>
         )}
         {typeBtn === "remove" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faTrash} /></i>
               {textBtn === undefined ? 'Удалить' : textBtn}
            </button>
         )}
         {typeBtn === "save" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faSave} /></i>
               {textBtn === undefined ? 'Сохранить' : textBtn}
            </button>
         )}
         {typeBtn === "finish" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faFlagCheckered} /></i>
               {textBtn === undefined ? 'Завершить' : textBtn}
            </button>
         )}
         {typeBtn === "archive" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faArchive} /></i>
               {textBtn === undefined ? 'Архивировать' : textBtn}
            </button>
         )}
         {typeBtn === "cancel" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faArrowRotateLeft} /></i>
               {textBtn === undefined ? 'Отмена' : textBtn}
            </button>
         )}
         {typeBtn === "send" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faPaperPlane} /></i>
               {textBtn === undefined ? 'Отправить' : textBtn}
            </button>
         )}
         {typeBtn === "play" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faPlay} /></i>
               {textBtn === undefined ? 'Активировать' : textBtn}
            </button>
         )}
         {typeBtn === "pay" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faCreditCard} /></i>
               {textBtn === undefined ? 'Оплатить' : textBtn}
            </button>
         )}
         {typeBtn === "receipt" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faReceipt} /></i>
               {textBtn === undefined ? 'Счет' : textBtn}
            </button>
         )}
         {typeBtn === "extend" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faForward} /></i>
               {textBtn === undefined ? 'Продлить' : textBtn}
            </button>
         )}
         {typeBtn === "extend" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faForward} /></i>
               {textBtn === undefined ? 'Продлить' : textBtn}
            </button>
         )}
         {typeBtn === "update" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faSync} /></i>
               {textBtn === undefined ? 'Обновить' : textBtn}
            </button>
         )}
         {typeBtn === "close" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faXmark} /></i>
               {textBtn === undefined ? 'Закрыть' : textBtn}
            </button>
         )}
         {typeBtn === "check" && (
            <button className={'srv_button ' + (size == 'lg' && 'btn-lg')} onClick={onClick} disabled={loading}>
               <i className="mr-5"><FontAwesomeIcon icon={faCheck} /></i>
               {textBtn === undefined ? 'Выбрать' : textBtn}
            </button>
         )}
      </>
   )
}

export default SrvButton;